<template>
<app-layout>
       <template v-slot:headerTitle>
         Edit StockItem Template
       </template>
       <template v-slot:headerNav>
            <nav-items></nav-items>
     </template>
       
        <div class="clearfix"></div>
        <br><br><br>
        <div class="container ">
        <div>
            <h5 class="pl-8 text-left mb-1 -mt-7">Edit Stockitem Template</h5>
               <ul style="padding-left:10px;" class="pt-2 pb-2 ">
                    <li class="pr-2 " style="float:left;" v-for="(v,k) in breadcrumbs">
                        <jet-nav-link
                            :href="route(v.route,1)"
                            :active="route().current(v.route)"
                        >
                            {{v.name}}
                        </jet-nav-link>
                        >
                    </li>
                </ul>
        </div>
        <div class="bg-white sm:mx-8 lg:mx-8 mt-9">
            <div class="row max-w-7xl mx-auto sm:px-6 lg:px-8 sm:mx-4 lg:mx-4 pt-3">
                   <div class=" form-group mt-1 merg text-left">
                                   <!-- devex start address -->
                        <div class="opt grid grid-cols-3 gap-10 flex justify-start ">
                            <div class="option col-span-1">
                                    <span> Company Name:</span>
                                    <DxSelectBox
                                        :data-source="company_names"
                                        :value="this.form_data.company_name"
                                        :accept-custom-value="true"
                                        @value-changed="fetchCompanyName($event)"
                                    />
                                </div>
                                <div class="option col-span-1">
                                        <span>Select File:</span>
                                                <div class="widget-container flex-box ledger_upload">
                                                                    <div
                                                                    id="dropzone-external"
                                                                    class="flex-box"
                                                                    :class="[isDropZoneActive
                                                                        ? 'dx-theme-accent-as-border-color dropzone-active'
                                                                        : 'dx-theme-border-color']"
                                                                    >
                                                                    <img
                                                                        id="dropzone-image"
                                                                        :src="imageSource"
                                                                        v-if="imageSource"
                                                                        alt=""
                                                                    >
                                                                    <div
                                                                        id="dropzone-text"
                                                                        class="flex-box"
                                                                        v-if="textVisible"
                                                                    >
                                                                        <span>Drag & Drop or Upload the  Excel file here</span>
                                                                    </div>
                                                                    <div
                                                                        id="dropzone-text"
                                                                        class="flex-box"
                                                                        v-if="uploaded_text_Visible"
                                                                    >
                                                                        <span >{{uploaded_text}}</span>
                                                                    </div>
                                                                    <DxProgressBar
                                                                        id="upload-progress"
                                                                        :min="0"
                                                                        :max="100"
                                                                        width="30%"
                                                                        :show-status="false"
                                                                        :visible="progressVisible"
                                                                        :value="progressValue"
                                                                    />
                                                                    </div>
                                                                </div>
                                                        <DxFileUploader
                                                            id="ledger-file-uploader"
                                                            dialog-trigger="#dropzone-external"
                                                            drop-zone="#dropzone-external"
                                                            accept="xlsx/*"
                                                            :multiple="false"
                                                            upload-mode="instantly"
                                                            upload-url="https://js.devexpress.com/Demos/NetCore/FileUploader/Upload"
                                                            :visible="false"
                                                            @drop-zone-enter="onDropZoneEnter"
                                                            @drop-zone-leave="onDropZoneLeave"
                                                            @uploaded="onUploaded"
                                                            @progress="onProgress"
                                                            @upload-started="onUploadStarted"
                                                            @value-changed="handleFileUpload($event)"
                                                        />
                                                        <!-- <button type="button" class="inventory-submit-btn" v-on:click="upload_excel($event)">Submit</button>   -->
                                        
                                </div>
                                <div class="option col-span-1 pt-2" id="sub"><button type="button" class="inventory-btn" v-on:click="upload_excel($event)">SubmitExcel</button></div>
                                </div>
                         </div>
                </div>
                <div class='row max-w-7xl mx-auto sm:px-6 lg:px-8'>
                    <div class="panel panel-info">
                        <div class="panel-heading">
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class=" grid lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 merg">
                                    <form name="createTRPLeadFrom" id="createTRPLeadFrom" method="POST">
                                        <div class=" ">
                                            <!-- devex start -->
                                            <div class="d-flex justify-content-start">
                                            <!-- devex start -->
                                            <!-- devex end -->
                                            <div class="">
                                            </div>
                                            &nbsp;
                                        </div>
                                        </div>
                                        <br>
                                        <div class="clearfix "></div>
                                        <DxDataGrid
                                            :data-source="dataSource"
                                            :columns="columns"
                                            :col-width="100"
                                            :show-borders="true"
                                        >
                                        <DxPaging :page-size="5"/>
                                        <DxPager
                                            :visible="true"
                                            :allowed-page-sizes="pageSizes"
                                            :display-mode="displayMode"
                                            :show-page-size-selector="showPageSizeSelector"
                                            :show-info="showInfo"
                                            :show-navigation-buttons="showNavButtons"
                                        />
                                        <DxScrolling column-rendering-mode="virtual"/>
                                        </DxDataGrid>
                                        <div class="" style="padding-left:16px ">
                                        
                                        </div>
                                        <!-- Excel Rendering Portion Starts -->
                                        <div class="clearfix create-trp-lead-from"></div>
                                        <div class="col testimonial-group mt-1">
                                            <br>
                                            <!-- <input type="button" class="btn btn-dark" value="Load more" ng-click="loadMore()" /> -->
                                        </div>
                                        <!-- Excel Rendering Portion Ends -->
                                        <div class="clearfix "></div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                        <!-- Form Upload ends -->
                            <!-- Main Card-box Starts -->
                    <div class="mb-2"></div>
                        <div class="grid grid-cols-4 merg text-left">
                            <div class="voucher-main-container col-span-4 lg:col-span-3 md:col-span-4 sm:col-span-3">
                                <div class="yellow-section" style="background-color: #E0F1FC;">
                                    <h6 class="pt-1 pl-2 pr-2">
                                        <span class="voucher-heading ">Create StockItems</span>
                                        <!-- <span><button  class="stockitem-submit-btn ml-1" style="float:right;" @click="additems($event)"  type="submit">StockItemName</button></span>   -->
                                    </h6>
                                </div>
                                <hr class="voucher-hr">
                                <!-- Rendering data in Voucher -->
                                <div>
                                <!-- devex start -->
                        <div>
                            <div class="dx-fieldset">
                            <div class="dx-field">
                                <div class="dx-field-label">NAME:</div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                    :data-source="Headers"
                                    :value="stock_items.NAME"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.NAME"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">PARENT: </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                    :data-source="Headers"
                                    :value="stock_items.PARENT"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.PARENT"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">CATEGORY:</div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                     :data-source="Headers"
                                    :value="stock_items.CATEGORY"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.CATEGORY"
                                />
                                </div>
                            </div>
                                <div class="dx-field">
                                <div class="dx-field-label">
                                GSTAPPLICABLE: </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                    :data-source="Headers"
                                    :value="stock_items.GSTAPPLICABLE"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.GSTAPPLICABLE"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                                DESCRIPTION: </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                     :data-source="Headers"
                                    :value="stock_items.DESCRIPTION"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.DESCRIPTION"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                                GSTTYPEOFSUPPLY:</div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                     :data-source="Headers"
                                    :value="stock_items.GSTTYPEOFSUPPLY"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.GSTTYPEOFSUPPLY"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                            BASEUNITS: </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                   :data-source="Headers"
                                    :value="stock_items.BASEUNITS"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.BASEUNITS"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                                ADDITIONALUNITS:  </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                    :data-source="Headers"
                                    :value="stock_items.ADDITIONALUNITS"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.ADDITIONALUNITS"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                                ISBATCHWISEON:  </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                    :data-source="Headers"
                                    :value="stock_items.ISBATCHWISEON"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.ISBATCHWISEON"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                                IGNOREPHYSICALDIFFERENCE:  </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                    :data-source="Headers"
                                    :value="stock_items.IGNOREPHYSICALDIFFERENCE"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.IGNOREPHYSICALDIFFERENCE"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                                IGNORENEGATIVESTOCK:  </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                  :data-source="Headers"
                                    :value="stock_items.IGNORENEGATIVESTOCK"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.IGNORENEGATIVESTOCK"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                                TREATSALESASMANUFACTURED: </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                    :data-source="Headers"
                                    :value="stock_items.TREATSALESASMANUFACTURED"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.TREATSALESASMANUFACTURED"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                                TREATPURCHASESASCONSUMED: </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                     :data-source="Headers"
                                    :value="stock_items.TREATPURCHASESASCONSUMED"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.TREATPURCHASESASCONSUMED"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                                TREATREJECTSASSCRAP:  </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                  :data-source="Headers"
                                    :value="stock_items.TREATREJECTSASSCRAP"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.TREATREJECTSASSCRAP"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                            HASMFGDATE: </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                :data-source="Headers"
                                    :value="stock_items.HASMFGDATE"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.HASMFGDATE"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                            ALLOWUSEOFEXPIREDITEMS: </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                    :data-source="Headers"
                                    :value="stock_items.ALLOWUSEOFEXPIREDITEMS"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.ALLOWUSEOFEXPIREDITEMS"
                                />
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">
                            CALCONMRP:  </div>
                                <div class="dx-field-value">
                                <DxSelectBox
                                :data-source="Headers"
                                    :value="stock_items.CALCONMRP"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="stock_items.CALCONMRP"
                                />
                                </div>
                            </div>
                            </div>
                        </div>
                           <!-- devex end -->
                            <div class="d-flex justify-content-center mb-3 p-1 mt-1">
                                <!-- Gst Details Card-box Starts -->
                                <div class="voucher-main-container " style="width: 90%;  height: 100%;">
                                    <div class="yellow-section" style="background-color: #E0F1FC;">
                                        <h6 class="pt-1 pl-2 pr-2">
                                            <span class="voucher-heading ">Gst Details</span>
                                            <!-- <span><button  class="stockitem-submit-btn ml-1" style="float:right;" @click="additems($event)"  type="submit">StockItemName</button></span>   -->
                                        </h6>
                                    </div>
                                    <hr class="voucher-hr">
                                       <!-- devex start -->
                            <div>
                                <div class="dx-fieldset">
                                <div class="dx-field">
                                    <div class="dx-field-label">APPLICABLEFROM: </div>
                                    <div class="dx-field-value">
                                    <DxSelectBox
                                        :data-source="Headers"
                                        :value="stock_items.APPLICABLEFROM"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="stock_items.APPLICABLEFROM"
                                    />
                                    </div>
                                </div>
                                <div class="dx-field">
                                    <div class="dx-field-label">CALCULATIONTYPE:  </div>
                                    <div class="dx-field-value">
                                    <DxSelectBox
                                        :data-source="Headers"
                                        :value="stock_items.CALCULATIONTYPE"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="stock_items.CALCULATIONTYPE"
                                    />
                                    </div>
                                </div>
                                <div class="dx-field">
                                    <div class="dx-field-label">HSNCODE: </div>
                                    <div class="dx-field-value">
                                    <DxSelectBox
                                        :data-source="Headers"
                                        :value="stock_items.HSNCODE"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="stock_items.HSNCODE"
                                    />
                                    </div>
                                </div>
                                    <div class="dx-field">
                                    <div class="dx-field-label">
                                    HSN: </div>
                                    <div class="dx-field-value">
                                    <DxSelectBox
                                      :data-source="Headers"
                                        :value="stock_items.HSN"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="stock_items.HSN"
                                    />
                                    </div>
                                </div>
                                <div class="dx-field">
                                    <div class="dx-field-label">
                                    TAXABILITY:  </div>
                                    <div class="dx-field-value">
                                    <DxSelectBox
                                        :data-source="Headers"
                                        :value="stock_items.TAXABILITY"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="stock_items.TAXABILITY"
                                    />
                                    </div>
                                </div>
                                <div class="dx-field">
                                    <div class="dx-field-label">
                                    ISREVERSECHARGEAPPLICABLE::</div>
                                    <div class="dx-field-value">
                                    <DxSelectBox
                                        :data-source="Headers"
                                        :value="stock_items.ISREVERSECHARGEAPPLICABLE"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="stock_items.ISREVERSECHARGEAPPLICABLE"
                                    />
                                    </div>
                                </div>
                                <div class="dx-field">
                                    <div class="dx-field-label">
                                ISNONGSTGOODS: </div>
                                    <div class="dx-field-value">
                                    <DxSelectBox
                                        :data-source="Headers"
                                        :value="stock_items.ISNONGSTGOODS"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="stock_items.ISNONGSTGOODS"
                                    />
                                    </div>
                                </div>
                                <div class="dx-field">
                                    <div class="dx-field-label">
                                GSTINELIGIBLEITC:   </div>
                                    <div class="dx-field-value">
                                    <DxSelectBox
                                        :data-source="Headers"
                                        :value="stock_items.GSTINELIGIBLEITC"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="stock_items.GSTINELIGIBLEITC"
                                    />
                                    </div>
                                </div>
                                <div class="dx-field">
                                    <div class="dx-field-label">
                                INCLUDEEXPFORSLABCALC:  </div>
                                    <div class="dx-field-value">
                                    <DxSelectBox
                                        :data-source="Headers"
                                        :value="stock_items.INCLUDEEXPFORSLABCALC"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="stock_items.INCLUDEEXPFORSLABCALC"
                                    />
                                    </div>
                                </div>
                                </div>
                            </div>
                                    <!-- devex end -->
                                     <div class="d-flex justify-content-center mb-3 p-1 mt-1">
                                <!-- Gst Details Card-box Starts -->
                                <div class="voucher-main-container " style="width: 90%;  height: 100%;">
                                    <div class="yellow-section" style="background-color: #E0F1FC;">
                                        <h6 class="pt-1 pl-2 pr-2">
                                                    <span class="voucher-heading ">RATEDETAILS</span>
                                                    <!-- <span><button  class="stockitem-submit-btn ml-1" style="float:right;" @click="additems($event)"  type="submit">StockItemName</button></span>   -->
                                                </h6>
                                            </div>
                                            <hr class="voucher-hr">
                                            <!-- devex start -->
                                            <div class="dx-fieldset">
                                                <div class="dx-field">
                                                        <div class="dx-field-label">
                                                    STATENAME: </div>
                                                        <div class="dx-field-value">
                                                        <DxSelectBox
                                                            :data-source="Headers"
                                                            :value="stock_items.STATENAME"
                                                            :accept-custom-value="true"
                                                            v-model:selectedItem="stock_items.STATENAME"
                                                        />
                                                        </div>
                                                    </div>
                                            </div>
                                            <!-- devex end -->
                                            <div class="d-flex justify-content-center mb-3 pt-1 pb-1">
                                                <!-- RATEDETAILS Card-box Starts -->
                                                <div class="voucher-main-container " style="width: 90%;  height: 100%;">
                                                    <div class="yellow-section"
                                                        style="background-color: #E0F1FC;">
                                                        <h6 class="pt-1 pl-2 pr-2">
                                                            <span class="voucher-heading ">RATEDETAILS</span>
                                                            <!-- <span><button  class="stockitem-submit-btn ml-1" style="float:right;" @click="additems($event)"  type="submit">StockItemName</button></span>   -->
                                                        </h6>
                                                    </div>
                                                    <hr class="voucher-hr">

                                                      <!-- devex start -->
                                                    <div class="">
                                                      
                                                       <div class="dx-fieldset" v-for="(v2,k2) in stock_items.GSTDETAILS">
                                                             <div class="dx-fieldset" v-for="(v3,k3) in v2.RATEDETAILS">
                                                             <div class="dx-field">
                                                                    <div class="dx-field-label">
                                                                GSTRATEDUTYHEAD:  </div>
                                                                    <div class="dx-field-value">
                                                                    <DxSelectBox
                                                                           :data-source="Headers"
                                                                            :value="v3.GSTRATEDUTYHEAD"
                                                                            :accept-custom-value="true"
                                                                            v-model:selectedItem="v3.GSTRATEDUTYHEAD"
                                                                    />
                                                                    </div>
                                                            </div>
                                                                <div class="dx-field"> 
                                                                    <div class="dx-field-label">
                                                               GSTRATEVALUATIONTYPE: </div>
                                                                    <div class="dx-field-value">
                                                                    <DxSelectBox
                                                                        :data-source="Headers"
                                                                            :value="v3.GSTRATEVALUATIONTYPE"
                                                                            :accept-custom-value="true"
                                                                            v-model:selectedItem="v3.GSTRATEVALUATIONTYPE"
                                                                    />
                                                                    </div>
                                                                </div>
                                                                <div class="dx-field">
                                                                    <div class="dx-field-label">
                                                                GSTRATE:  </div>
                                                                    <div class="dx-field-value">
                                                                    <DxSelectBox
                                                                         :data-source="Headers"
                                                                            :value="v3.GSTRATE"
                                                                            :accept-custom-value="true"
                                                                            v-model:selectedItem="v3.GSTRATE"
                                                                    />
                                                                    </div>
                                                                </div> 
                                                        </div>
                                                        </div>
                                                    </div>
                                            <!-- devex end -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mb-3 p-2 mt-2">
                                <!-- MRPDETAILS Card-box Starts -->
                                <div class="voucher-main-container " style="width: 90%;  height: 100%;" >
                                    <div class="yellow-section" style="background-color: #E0F1FC;">
                                        <h6 class="pt-1 pl-2 pr-2">
                                            <span class="voucher-heading ">MRPDETAILS</span>
                                            <!-- <span><button  class="stockitem-submit-btn ml-1" style="float:right;" @click="additems($event)"  type="submit">StockItemName</button></span>   -->
                                        </h6>
                                    </div>
                                    <hr class="voucher-hr">
                                    <!-- devex start -->
                                            <div class="dx-fieldset">
                                                <div class="dx-field">
                                                        <div class="dx-field-label">
                                                    FROMDATE: </div>
                                                        <div class="dx-field-value">
                                                        <DxSelectBox
                                                               :data-source="Headers"
                                                                :value="stock_items.FROMDATE"
                                                                :accept-custom-value="true"
                                                                v-model:selectedItem="stock_items.FROMDATE"
                                                        />
                                                        </div>
                                                    </div>
                                                    <div class="dx-field">
                                                        <div class="dx-field-label">
                                                    STATENAME:  </div>
                                                        <div class="dx-field-value">
                                                        <DxSelectBox
                                                            :data-source="Headers"
                                                            :value="stock_items.STATENAME"
                                                            :accept-custom-value="true"
                                                            v-model:selectedItem="stock_items.STATENAME"
                                                        />
                                                        </div>
                                                    </div>
                                            </div>
                                            <!-- devex end -->
                                </div>
                            </div>
                        </div>
                        &nbsp;
                    </div>
                    <div class="voucher-main-container col-span-4 lg:col-span-1 md:col-span-4 sm:col-span-1" >
                        <h6 class="pt-1 pl-2 pr-2 yellow-section">
                            <span class="voucher-heading">SAVE</span>
                        </h6>
                        <hr class="voucher-hr">
                         <!-- devex start address -->
                                <div class="stockItemoptions">
                            <div class="option">
                                <span> Type:</span>
                                <DxSelectBox
                                    :items="['Voucher', 'Master']"
                                    :value="this.form_data.type"
                                    :accept-custom-value="true"
                                    @value-changed="drop_down_change($event)"
                                />
                                 <div class="option"  v-if="is_visible=='Master'" >
                                <span> SubType:</span>
                                <DxSelectBox
                                    :items="['StockGroup','Ledger','Group','StockItem','Godown','Unit']"
                                    :value="this.form_data.Subtype"
                                    :accept-custom-value="true"
                                    @value-changed="getMaster($event)"
                                />
                                </div>
                                 <div class="option"   v-if="is_visible=='Voucher'">
                                <span> SubType:</span>
                                <DxSelectBox
                                    :items="['Sales','Purchase','Recieve','Payment','Credit Note','Debit Note']"
                                    :value="this.form_data.Subtype"
                                    :accept-custom-value="true"
                                    @value-changed="getVoucher($event)"
                                />
                                </div>
                            <div class="option">
                                <span>Name:</span>
                                <DxTextBox
                                    :value="template_name"
                                    :accept-custom-value="true"
                                    @value-changed="getTemplateName($event)"
                                />
                            </div>
                         </div>
                        </div>
                          <!-- devex end address -->
                       <div class="grid grid-cols-4 gap-1">
                                <div class="col-span-3"></div>
                                <div class="col-span-1 ">
                                    <button type="button"  class="inventory-btn " style="float: right"
                                      @click="save_json($event)">Update</button>
                                </div>
                        </div>
                    </div>
                </div> 
                <DxToast
                        v-model:visible="isVisible"
                        v-model:message="message"
                        v-model:type="toastType"
                />
            </div>
           </div>
        </div>
    </app-layout>
</template>
<script>
import navItems from "@include/pages/modules/Components/nav_items";
import { DxToast } from 'devextreme-vue/toast';
import DxNumberBox from 'devextreme-vue/number-box';
import JetNavLink from '@/Jetstream/NavLink.vue';
import AppLayout from '@include/pages/BaseLayouts/tallyClinicAppLayout.vue';
import { DxFileUploader } from 'devextreme-vue/file-uploader';
import { DxProgressBar } from 'devextreme-vue/progress-bar';
import {DxDataGrid,DxPaging,DxPager} from 'devextreme-vue/data-grid';
import DxTextBox from 'devextreme-vue/text-box';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';
import {isElectron,getCompanyNames} from '../../../UtilsJs/utils.js';
import { DxTextArea } from 'devextreme-vue/text-area';
import DxSelectBox from 'devextreme-vue/select-box';
import ArrayStore from 'devextreme/data/array_store';
import {upload,saveJson} from '../../TemplateJs/ledger_template_db.js';
export default {
    props:{
    id:"",
    type:"",
    subtype:"",
    obj_view:"",
    json_template:"",
    template_name:"",
    cmp_name:"",
    template_load_count:0
    },  
    components:{
        DxToast,
        DxNumberBox,
        AppLayout,
        DxSelectBox, 
        DxForm,
        DxTextArea,
        DxGroupItem,
        DxSimpleItem,
        DxLabel,
        DxTextBox,
        DxFileUploader,
        DxDataGrid,
        JetNavLink,
        DxProgressBar,
        DxPager,
        DxPaging,
        navItems
    },
    computed:{
        valueString() {
            let mod = JSON.stringify(this.stock_items, null, 2);
            return mod;
        },
    },
    data:function(){
         return{
            isVisible: false,
            message: '',
            toastType: 'info',
            displayMode: 'full',
            pageSizes: [5, 10, 'all'],
            showPageSizeSelector: true,
            showInfo: true,
            showNavButtons: true,
            input_filling_check:"",
            uploaded_text_Visible:false,
            uploaded_text:"",
            isDropZoneActive: false,
            imageSource: '',
            textVisible: true,
            progressVisible: false,
            progressValue: 0,
            dataSource: [],
            columns: [],
              data: new ArrayStore({
              key: 'ID',
              }),
               positionOptions: {
                items:["-NA-"],
                value: '',
            },
            formRefName: 'tree-view',
            stock_items:{},
            stockitem_Exceldata:[],
            Headers:[],
            file: '',
            is_visible:"",
            is_tally_open :false,
            typeArr:[{"value":"Voucher","label":"Voucher"},{"value":"Master","label":"Master"}],
            voucherTypeArr:[{"value":"Sales","label":"Sales"},
                {"value":"Purchase","label":"Purchase"},
                {"value":"Recieve","label":"Recieve"},
                {"value":"Payment","label":"Payment"},
                {"value":"CreditNote","label":"CreditNote"},
                {"value":"DebitNote","label":"DebitNote"}],
            masterTypeArr:[
                {"value":"StockGroup","label":"StockGroup"},
                {"value":"Ledger","label":"Ledger"},
                {"value":"Group","label":"Group"},
                {"value":"StockItem","label":"StockItem"},
                {"value":"Godown","label":"Godown"},
                {"value":"Unit","label":"Unit"}
            ],
            form_data:{"type":"","Subtype":"","Name":"","company_name":""},
            typeOptions:{
                items:['Voucher','Master']
            },
            VoucherSubTypeOptions:{
                items:['Sales','Purchase','Recieve','Payment','Credit Note','Debit Note']     
            },
            MasterSubTypeOptions:{ 
                items:['StockGroup','Ledger','Group','StockItem','Godown','Unit']  
            },
            company_name:"",
            company_names:[],
            breadcrumbs:[{'route':'templates.index','name':'Templates'},{'route':'templates.show','name':'Show Template'}]

         }
     },
     methods:{
         getTemplateName(e){
             this.form_data.Name=e.value;
         },
         getVoucher(e){
            this.form_data.Subtype=e.value;
         },
         getMaster(e){
            this.form_data.Subtype=e.value;
         },
        addAddress(){
            this.ledgers.ADDRESS.ADDRESS.push("");
        },
        handleFileUpload(e){
         this.file = e.value;
        },
        upload_excel(e){
            e.preventDefault();
            var _this = this;
            // console.log(this.file[0])
            upload(_this,this.file[0]);
        },  
        save_json:function(e){
            e.preventDefault();
          var formData = $('#form').serializeArray();
          var company_name = $('#cmp_name').val();
          let json_template = JSON.stringify(this.stock_items, null, 2);    
          let url = '/templates/update_template';
          let params = {'form_data':this.form_data,'company_name':this.form_data.company_name,template:json_template,'id':this.id};
          saveJson(url,params);
        },
        drop_down_change(e){
            this.form_data.type=e.value;
            if(e.value == "Voucher"){
                this.is_visible = "Voucher";
            } 
            else if(e.value == "Master"){
                this.is_visible = "Master";
            }
           // changeSubtype(type);
        },
         onDropZoneEnter(e){
            if (e.dropZoneElement.id === 'dropzone-external') {
                this.isDropZoneActive = true;
            }
        },
        onDropZoneLeave(e){
            if (e.dropZoneElement.id === 'dropzone-external') {
                this.isDropZoneActive = false;
            }
        },
        viewExcelData(e){
            var _this = this;
            // getExcelSheetDataView(_this,this.file[0]);
            this.isDataViewModalVisible = true;
        },
        onUploaded(e){
            const { file } = e;
            const fileReader = new FileReader();
            fileReader.onload = () => {
                this.isDropZoneActive = false;
                this.imageSource = fileReader.result;
            };
            fileReader.readAsDataURL(file);
            this.textVisible =false;
            this.progressVisible = false;
            this.uploaded_text_Visible=true;
            this.uploaded_text=e.file.name;
            this.progressValue = 0;
            var _this = this;
            // getExcelSheetDataView(_this,this.file[0]);
        },
        onProgress(e) {
            this.progressValue = (e.bytesLoaded / e.bytesTotal) * 100;
        },
        onUploadStarted() {
            this.imageSource = '';
            this.progressVisible = true;
        },
        fetchCompanyName(e){
            this.company_name=e.value;
        }
     },
     mounted(){
            if(this.template_load_count == 1){
                 location.reload();
            }
            // console.log(this.cmp_name)
            this.stock_items = this.json_template;
            this.is_visible = this.type;
            this.form_data.type=this.type;
            this.form_data.Subtype=this.subtype;
            this.form_data.Name=this.template_name;
            this.form_data.company_name = this.cmp_name;
           $('#type').on('change', function () {
                if($(this).val()=="Voucher"){
                    $('#Voucher').css('display','block');
                    $('#Master').css('display','none');
                }
                else{
                    $('#Voucher').css('display','none');
                    $('#Master').css('display','block');
                };  
            })
            $('#VOUCHERTYPENAME').on('change', function () {
                //$('#VOUCHERTYPENAME').css('display', 'block');
                if ($(this).val() == "Custom") {
                    $(this).attr('class', function () {
                        return "col-md-3";
                    })
                    $('#Custom_VOUCHERTYPENAME').css('display', 'inline');
                    $('.voucher_refreshbutton').css('display', 'inline');
                }
            })
            $(document).on('change', '#LEDGERNAME', function () {
                //$('#LEDGERNAME').css('display', 'block');
                if ($(this).val() == "Custom") {
                    $(this).parent().find('.Custom_ledger_show').css('display', 'inline')
                    $(this).parent().find('.refreshbutton').css('display', "inline")
                    $(this).attr('class', function () {
                        return "voucher-select col-md-3 ";
                    })
                }
            })
     },
    created:function(){
           var _this=this;
            if(isElectron()){
                this.metas = "electron";
                window.api.send('checkTallyOpening'); 
                window.api.receive("checkTallyOpening-reply", (tally_response) => {
                        //_this.ledger_names = ledger_obj;
                       
                        // getLedgerNames(_this,this.metas);  
                        // getVoucherTypeNames(_this,this.metas);
                        if(tally_response == "tally is open"){
                         getCompanyNames(_this,this.metas);
                        }
                        else{
                            this.isVisible=true;
                            this.message='Tally Is Not Open';
                            this.toastType='info';
                        }
                });
            }
            else{
                axios.post('/checkTallyIsOpen')
                .then((result) => {
                    if(result.data=="not_open"){
                        alert('tally is not open');
                    }
                    else{
                        getCompanyNames(_this,this.meta);
                        // getLedgerNames(_this,this.meta);  
                        // getVoucherTypeNames(_this,this.meta);
                    }
                })
            }
    }
}
</script>
<style>
.crumb1{
  padding:10px;
}
.crumb1 li
{
  display: inline-block;
  padding: 1px;
  background: transparent;
  transform: skew(-20deg);
  cursor: pointer;
  opacity: 0.8;
}

.crumb1 li:hover
{
  opacity: 1;
}
li {
    border: none!important;
}
.stockItemoptions {
  padding: 20px;
}
.container{
    max-width: 1340px;
}
 /* .box {
        border: 2px solid rgb(136, 136, 243);
        width: 550px;
    } */
    h6 {
        /* margin-block-start: 0px; */
        /* border-radius: 0px 0px 10px 10px; */
        margin: 0px 0px 0px !important;
        padding: 0px 0px 7px !important;
    }
    .key_data {
        padding-left: 1%;
        padding-right: 1%;
    }
    .inventory_header {
        margin-block-start: 0px;
        background-color: rgb(111, 203, 219);
        padding: 10px;
        border-radius: 10px 10px 10px 10px;
    }
    .ledger_header {
        margin-block-start: 0px;
        background-color: rgb(111, 203, 219);
        padding: 10px;
        border-radius: 10px 10px 10px 10px;
    }
    #amt {
        visibility: hidden;
    }
    #inventory {
        /* border: 2px solid lightgrey !important;
            border-top: none !important; */
    }
    #ledgers {
        /* border: 2px solid lightgrey !important;
            border-top: none !important; */
    }
    .btn {
        padding: 0 2% 0 2%;
    }
    .upload_box {
        width: 400px;
        box-sizing: border-box;
    }
     .upbtn {
        margin-top: 7px;
    }
    .voucher-heading {
        font-size: 12px;
    }
    .stockitem-submit-btn {
        font-size: 12px;
        border: 1px solid #2A66B1;
        color: #FFFFFF;
        padding-top: 3px;
        padding-bottom: 3px;
        padding-left: 10px;
        padding-right: 10px;
        background-color: #2A66B1;
    }
    .testimonial-group {
        padding: 0px !important;
    }
    .voucher-main-container {
        border: 1px solid #CECECE;
    }
    .voucher-hr {
        margin: 0px !important;
    }
    .file_upload[type='file'] {
        color: #2A66B1;
        font-size: 12px;
        border: 1px solid #2A66B1;
    }
    .voucher-select {
        border: 1px solid #CECECE;
    }
    .voucher-label {
        font-size: 12px;
        font-weight: bold;
    }
    .file_upload[type=file]::file-selector-button {
        border: 0px solid #2A66B1;
        padding: .4em .2em;
        color: #FFFFFF;
        border-radius: 0px !important;
        background-color: #2A66B1;
    }
    .voucher-select::after {
        color: #CECECE;
    }
    .display-block {
        display: inline;
    }
    .yellow-section {}
    .create-trp-lead-from {
        margin-top: -22px !important;
    }
    .refreshbutton {
        font-size: 12px;
        width: 20px !important;
        height: 20px !important;
        border: 0px solid #2A66B1;
        background-color: #2A66B1;
        border-radius: 100px;
        color: #FFFFFF;
        font-weight: 500;
    }
    .voucher_refreshbutton {}
    /* by rahul  end*/
    /* .stock{
        font-weight: bold;
        font-size: small;
    } */
     .inventory-submit-btn {
  font-size: 12px;
  border: 1px solid #2A66B1;
  color: #FFFFFF;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #2A66B1;
  /* margin-left: -800px; */
  margin-top: 20px;
}
#create_stock{
    border: 1px solid gray;
}
.sub{
   margin-top: 30px;
   margin-left: -203px;
 }
 .master{
    margin-top: 30px;
   margin-left: -210px;
 }
/* responsive */
/* @media (max-width: 640px) {
    .right{
         display: none;
     }
 .rightwo{
     display: block;
     margin-left: 50px;  
 }
 } */
@media (max-width: 640px) {
 .font{
     font-size: 11px;
 }
.merg{
    margin-left: 15px;
    margin-right: 15px;
}
 }
 @media (min-width: 768px) {
     /* .break{
         display:block;
     } */
  }
  @media (min-width: 1024px) {
   }
  @media (min-width: 1280px) {
  }
  @media (min-width: 1536px) {
  }
  .name{
     margin-left: 8rem;
    margin-right:5rem ;
  }
  .first-group{
      margin-right: -200px;
  }
   .main-content {
background-color: #F3F4F6;
    /* width: calc(100% - 250px); */
    /* height: 100vh; */
    margin-left: 212px;
    padding-bottom: 10px;
   }
  #progressbar {
        margin-bottom: 30px;
        overflow: hidden;
        color: lightgrey
    }
    #progressbar .active {
        color: #000000
    }
    /*  */
    #progressbar li {
        list-style-type: none;
        font-size: 15px;
        width: 25%;
        float: left;
        position: relative;
        font-weight: 400
    }
    #progressbar #select:before {
        content: "1";
        /*--You can add font icon code here--*/
        font-family: FontAwesome;
        /* color: #000000; */
    }
    #progressbar #verify:before {
        font-family: FontAwesome;
        content: "2";
    }
    #progressbar #import:before {
        font-family: FontAwesome;
        content: "3";
    }
    #progressbar li:before {
        width: 50px;
        height: 50px;
        line-height: 45px;
        display: block;
        font-size: 20px;
        color: #FFFFFF;
        background: lightgray;
        border-radius: 50%;
        margin: 0 auto 10px auto;
        padding: 2px;
        /* z-index: -1; */
    }
    #progressbar li:after {
        content: '';
        width: 100%;
        height: 2px;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        background: lightgray;
        position: absolute;
        left: 0;
        top: 25px;
        z-index: 1
    }
    #progressbar li.active:before,
    #progressbar li.active:after {
        background: #FDFD96;
        color:black;
    }
    #progressbar li #verify:before{
        background: #FDFD96;
        color:black;
    }
    #progressbar li #important:before{
        background: #FDFD96;
        color:black;
    }
    .fit-image {
        width: 100%;
        object-fit: cover
}
    .progress-style {
        margin-right: auto;
        margin-left: auto;
    }
    .pallete-green{
        background-color:rgb(156, 203, 169) ;
    }
 .auto-margin{
    margin-left: auto;
    margin-right: auto;
 }  
 .Related {
        margin-top: 50px;
        font-size: 22px;
        font-weight: 600;
        text-align: center;
    }
    .container{
          text-align: center;
    }
        /* upload image devex */
        #dropzone-external {
  width: 320px;
  height: 70px;
  background-color: rgba(183, 183, 183, 0.1);
  border-width: 2px;
  border-style: dashed;
  padding: 10px;
}
#dropzone-external > * {
  pointer-events: none;
}
#dropzone-external.dropzone-active {
  border-style: solid;
}
.widget-container > span {
  font-size: 14px;
  /* font-weight: bold; */
  margin-bottom: 5px;
  margin-top: 7px;
  margin-right: 240px;
}
#dropzone-image {
  max-width: 70%;
  max-height: 70%;
}
#dropzone-text > span {
  font-weight: 100;
  opacity: 0.5;
}
#upload-progress {
  display: flex;
  margin-top: 10px;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  #dropzone-external {
  width: 180px;
}
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  #dropzone-external {
  width: 180px;
}
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
     #dropzone-external {
  width: 200px;
}
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
     #dropzone-external {
  width: 230px;
}
}
@media only screen and (min-width: 1024px) {
     #dropzone-external {
  width: 260px;
}
}
@media only screen and (min-width: 1284px) {
    #dropzone-external {
     width: 280px;
    }
}
@media only screen and (min-width: 1536px) {
    #dropzone-external {
        width: 320px;
    }
}
.inventory-btn {
  font-size: 12px;
  border: 1px solid #2A66B1;
  color: #FFFFFF;
  margin-top: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #2A66B1;
}
.dx-toast-content {
  min-width: 300px;
  max-width: 400px;
}
</style>